import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { IEventTP } from '../interface/IEventTP';
import { ISessionsTP } from '../interface/ISessionsTP';
import { ISchedule } from '../interface/ISchedule'

export const callApiV2 = createApi({
    reducerPath: 'callApiV2',
    baseQuery: fetchBaseQuery({
        baseUrl: 'api',
        prepareHeaders: (headers, { getState }: { getState: any }) => {
            const token = getState().token.value;
            if (token) {
                headers.set("Authorization", `Bearer ${token.Token}`);
            }
            return headers;
        },
    }),
    keepUnusedDataFor: 0,
    // global configuration for the api
    refetchOnMountOrArgChange: 0,
    tagTypes: ['Users', 'Shows', 'News', 'Troupes', 'Exhibitions', 'DocumentationsList', 'Documents', 'SchemeHall', 'RedirectUrls'],
    endpoints: (builder) => ({
        getEventTP: builder.mutation<IEventTP, string>({
            query: (id: string) => ({
                url: `/shows/GetEventsTP/${id}`
            })
        }),
        getSessionsTP: builder.mutation<ISessionsTP, string>({
            query: (id: string) => ({
                url: `/shows/GetSessionsTP/${id}`
            })
        }),
        addSessionsTP: builder.mutation<any, ISchedule>({
            query: (body: ISchedule) => ({
                url: `/shows/AddSessionsTP`,
                body: body,
                method: 'POST'
            })
        })
    })
})

export const {
    useGetEventTPMutation,
    useGetSessionsTPMutation,
    useAddSessionsTPMutation,
} = callApiV2